import canAutoPlay from 'can-autoplay'

export const checkAutoPlay = (): Promise<boolean> => {
  console.warn('Autoplay check in progres...')
  return canAutoPlay.video().then(({ result }) => result)
}
